module.exports = __webpack_public_path__ + "img/lg_ring_r_i_0_null.8bdea8cb.png";